import './App.css';
import React from "react";

function Error () {
  return <div className="Error">
This page doesn't exists.
  </div>
}

export default Error;